<template>
  <div class="main-wrapper blog">
    <user-header></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content blog-details">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
            <!-- Blog -->
            <div class="featured-venues-item">
              <div class="listing-item blog-info">
                <div class="listing-img">
                  <router-link to="/blog/blog-details">
                    <img
                      src="@/assets/img/blog/blog-04.jpg"
                      class="img-fluid"
                      alt="Venue"
                    />
                  </router-link>
                  <div class="fav-item-venues news-sports">
                    <span class="tag tag-blue">Badminton</span>
                  </div>
                </div>
                <div class="listing-content news-content">
                  <div
                    class="listing-venue-owner blog-detail-owner d-lg-flex justify-content-between align-items-center"
                  >
                    <div class="navigation">
                      <a href="javascript:void(0)"
                        ><img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          alt="User"
                        />Orlando Waters</a
                      >
                      <span><i class="feather-calendar"></i>15 May 2023</span>
                      <span><i class="far fa-comment-alt"></i>30 Comments</span>
                    </div>
                    <a class="btn btn-primary"
                      ><img
                        src="@/assets/img/icons/grid.svg"
                        class="img-fluid"
                        alt="Icon"
                      />Rules of Game</a
                    >
                  </div>
                  <!-- <hr> -->
                  <h2 class="listing-title">
                    <a href="javascript:void(0)"
                      >Mastering the Badminton Basics: A Guide for Beginners</a
                    >
                  </h2>
                  <p>
                    There are many variations of passages of at Lorem Ipsum available but
                    the majority suffered that dummy is alteration. There are many
                    variations of passages of Lorem Ipsum available but the or majority
                    have that suffered alteration words which don't look even slightly
                    believable. There are many available but the majority the have
                    suffered alteration. There are many variations of dummy passages Lorem
                    majority the have the suffered alteration.
                  </p>

                  <p>
                    There are many variations of passages of at Lorem Ipsum available but
                    the majority the have too suffered alteration. There are many
                    variations of passages of Lorem Ipsum available majority have that
                    suffered alteration words which don't look even slightly believable.
                    There are available but the majority the have suffered alteration.
                  </p>
                  <div
                    class="gradient-bg d-flex justify-content-between align-items-center"
                  >
                    <img
                      src="@/assets/img/icons/comment-quotes.svg"
                      class="img-fluid"
                      alt="Icon"
                    />
                    <p class="mb-0">
                      There are many variations of passages of at Lorem Ipsum available
                      but the majority the have too suffered alteration. There are many
                      variations of passages of Lorem Ipsum vailable majority have that
                      suffered alteration words which don't look even slightly believable.
                    </p>
                  </div>
                  <p>
                    Lorem Ipsum available but the or majority have that suffered
                    alteration words which don't look even slightly believable. There are
                    many available but the majority the have suffered alteration. There
                    are many variations of dumm passages Lorem majority the have the
                    suffered alteration.
                  </p>
                  <div
                    class="blog-images d-sm-flex align-items-center justify-content-start"
                  >
                    <a href="javascript:void(0)"
                      ><img
                        src="@/assets/img/blog/blog-05.jpg"
                        class="img-fluid"
                        alt="Venue"
                    /></a>
                    <a href="javascript:void(0)"
                      ><img
                        src="@/assets/img/blog/blog-06.jpg"
                        class="img-fluid"
                        alt="Venue"
                    /></a>
                    <a href="javascript:void(0)"
                      ><img
                        src="@/assets/img/blog/blog-07.jpg"
                        class="img-fluid"
                        alt="Venue"
                    /></a>
                  </div>
                  <p>
                    Lorem Ipsum available but the or majority have that suffered
                    alteration words which don't look even slightly believable. There are
                    many available but the majority the have suffered alteration. There
                    are many variations of dummy passages Lorem majority the have the
                    suffered alteration. There are many variations of passages of at Lorem
                    Ipsum available but the majority suffered that dummy is alteration.
                    There are many variations of passages of Lorem Ipsum available but the
                    or majority have that suffered alteration words which don't look even
                    slightly believable.
                  </p>
                  <ul class="text-list">
                    <li>dummy passages Lorem majority</li>
                    <li>Lorem Ipsum is not simply random text</li>
                    <li>It has roots in a piece of classical Latin literature</li>
                    <li>There are many variations of passages of Lorem Ipsum</li>
                    <li>Various versions have evolved over the years</li>
                  </ul>
                  <p>
                    Lorem Ipsum available but the or majority have that suffered
                    alteration words which don't look even slightly believable. There are
                    many available but the majority the have suffered alteration. There
                    are many variations of dumm passages Lorem majority the have the
                    suffered alteration.
                  </p>
                </div>
                <!-- <hr> -->
              </div>
              <div class="row align-items-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="d-flex align-items-center tags-wrapper">
                    <h6>Tags:</h6>
                    <ul class="tags">
                      <li><a href="javascript:void(0);" class="tag">Rackets</a></li>
                      <li><a href="javascript:void(0);" class="tag">New Game</a></li>
                      <li><a href="javascript:void(0);" class="tag">Dresses</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                  <div
                    class="d-flex justify-content-lg-end align-items-center social-medias-wrapper"
                  >
                    <h6>Share on :</h6>
                    <ul class="social-medias d-flex">
                      <li class="facebook">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-facebook-f"></i
                        ></a>
                      </li>
                      <li class="linkedin">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-linkedin"></i
                        ></a>
                      </li>
                      <li class="instagram">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-instagram"></i
                        ></a>
                      </li>
                      <li class="twitter">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-twitter"></i
                        ></a>
                      </li>
                      <li class="pinterest">
                        <a href="javascript:void(0);"
                          ><i class="fa-brands fa-pinterest"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Blog -->
            <!-- Author Comments -->
            <div class="blog-comments">
              <div class="dull-bg author-widget">
                <div
                  class="author-group d-md-flex align-items-center justify-content-start"
                >
                  <div class="profile-pic">
                    <a href="javascript:void(0);" class="d-inline-block"
                      ><img src="@/assets/img/profiles/avatar-01.jpg" alt="User"
                    /></a>
                  </div>
                  <div class="info">
                    <span>Author</span>
                    <h5>Antony Hilfn</h5>
                    <p>
                      Lorem Ipsum available but the or majority have that suffered
                      alteration words which don't look even slightly believable. There
                      are many available but the majority the have suffered alteration.
                      There are many variations of dumm passages Lorem majority the have
                      the suffered alteration.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Author Comments -->

            <!-- Comments -->
            <div class="blog-comments">
              <div class="dull-bg">
                <h4 class="mb-0">Comments (45)</h4>
                <hr />
                <ul>
                  <li
                    class="author-group d-md-flex align-items-center justify-content-start"
                    v-for="record in Blog_Details_Comment"
                    :key="record.id"
                  >
                    <div class="profile-pic">
                      <a href="javascript:void(0);" class="d-inline-block"
                        ><img
                          :src="require(`@/assets/img/profiles/${record.Image}`)"
                          alt="User"
                      /></a>
                    </div>
                    <div class="info">
                      <div class="head d-flex align-items-center justify-content-start">
                        <h5>{{ record.Name }}</h5>
                        <i class="fa-solid fa-circle"></i>
                        <span>15 Mar 2023</span>
                      </div>
                      <p>
                        Lorem Ipsum available but the or majority have that suffered
                        alteration words which don't look even slightly believable. There
                        are many available but the majority the have suffered alteration.
                        There are many variations of dumm passages Lorem majority the have
                        the suffered alteration.
                      </p>
                      <a href="javascript:void(0);">Reply</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- /Comments -->
            <div class="card new-comment white-bg">
              <h4>Enter Details</h4>
              <form>
                <div class="mb-3">
                  <label for="name" class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Enter Name"
                  />
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    placeholder="Enter Email Address"
                  />
                </div>
                <div class="mb-3">
                  <label for="name" class="form-label">Phone Number</label>
                  <input
                    type="text"
                    class="form-control"
                    id="phonenumber"
                    placeholder="Enter Phone Number"
                  />
                </div>
                <div class="mb-3">
                  <label for="comments" class="form-label">Details</label>
                  <textarea
                    class="form-control"
                    id="comments"
                    rows="3"
                    placeholder="Enter Comments"
                  ></textarea>
                </div>
                <button type="submit" class="btn btn-gradient">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <section class="section dull-bg similar-list">
        <div class="container">
          <h2 class="text-center mb-40">Similar Listing</h2>
          <div class="row">
            <div class="featured-slider-group">
              <div class="owl-carousel featured-venues-slider owl-theme">
                <!-- Blog -->
                <Carousel
                  :wrap-around="true"
                  :settings="settings"
                  :breakpoints="breakpoints"
                >
                  <Slide v-for="item in Blog_Details" :key="item.id">
                    <div class="featured-venues-item text-start">
                      <div class="listing-item mb-0">
                        <div class="listing-img">
                          <router-link to="/blog/blog-details">
                            <img
                              :src="require(`@/assets/img/venues/${item.Images}`)"
                              alt="Venue"
                            />
                          </router-link>
                          <div class="fav-item-venues news-sports">
                            <span class="tag tag-blue">{{ item.Sports }}</span>
                            <div class="list-reviews coche-star">
                              <a
                                href="javascript:void(0)"
                                class="fav-icon"
                                @click="toggleSelected(item)"
                              >
                                <i class="feather-heart"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="listing-content news-content">
                          <div class="listing-venue-owner">
                            <div class="navigation">
                              <a href="javascript:void(0)"
                                ><img
                                  :src="require(`@/assets/img/profiles/${item.User}`)"
                                  alt="User"
                                />{{ item.Name }}</a
                              >
                              <span><i class="feather-calendar"></i>{{ item.Date }}</span>
                            </div>
                          </div>
                          <h3 class="listing-title blog-title">
                            <a href="javascript:void(0)">{{ item.Title }}</a>
                          </h3>
                          <div class="listing-button read-new">
                            <ul class="nav">
                              <li><i class="feather-heart"></i>{{ item.Like }}</li>
                              <li>
                                <i class="feather-message-square"></i>{{ item.Comment }}
                              </li>
                            </ul>
                            <span
                              ><img
                                :src="require(`@/assets/img/icons/${item.Clock}`)"
                                alt="Icon"
                              />{{ item.Lastseen }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                  <template #addons>
                    <Navigation />
                  </template>
                </Carousel>
                <!-- /Blog -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Blog_Details from "@/assets/json/blog-details.json";
import Blog_Details_Comment from "@/assets/json/blog-details-comment.json";
export default {
  data() {
    return {
      Blog_Details_Comment: Blog_Details_Comment,
      Blog_Details: Blog_Details,
      title: "Blog Details",
      text: "Home",
      text1: "Blog Details",
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
